import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';

export const SAP_BASIC_02_Schema = {
  fields: {
    no: { initial: '', label: '행 식별자' },
    newYn: { initial: 'N', label: '신규 여부' },

    managerId: { initial: '', label: '사용자 ID' },
    managerNm: { initial: '', label: '성명' },
    position: { initial: '', label: '직책' },
    rank: { initial: '', label: '직급' },
    depNm: { initial: '', label: '부서명' },
    manageDate: {
      initial: dayjs().format('YYYY-MM-DD'),
      label: '선임일',
      required: 'Y',
    },

    fileName: { initial: '', label: '파일명' },
    saveName: { initial: '', label: '저장 파일명' },
    filePath: { initial: '', label: '파일 경로' },

    previewFilePath: { initial: '', label: '미리보기 파일 경로' },
    createDate: { initial: '', label: '생성일자' },
    createId: { initial: '', label: '생성자 ID' },
    updateDate: { initial: '', label: '수정일자' },
    updateId: { initial: '', label: '수정자 ID' },
    mapFile: { initial: '', label: '첨부파일' },
  },
  modal: {
    grid: {
      position: { initial: '', label: '직책' },
      rank: { initial: '', label: '직급' },
      depNm: { initial: '', label: '부서명' },
      evaStartDate: { initial: '', label: '평가기간(시작)' },
      evaEndDate: { initial: '', label: '평가기간(종료)' },
    },
    form: {
      evaStartDate: {
        initial: dayjs().format('YYYY-MM-DD'),
        label: '평가기간(시작)',
      },
      evaEndDate: {
        initial: dayjs().format('YYYY-MM-DD'),
        label: '평가기간(종료)',
      },
      grade: { initial: '', label: '평가등급' },
      opinion: { initial: '', label: '종합의견' },
      improvements: { initial: '', label: '개선사항' },
      evaluationItems: { initial: [], label: '평가항목' }, // 배열 초기값 추가
      managerNm: { initial: '', label: '책임자' },
    },
  },
  mapper: {
    search1: {
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd || ''
        ),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || ''),
    },
    /** GetSapBasic02R2 — WHERE M.BPM_ID = @BpmId AND A.BPD_ID = @BpdId */
    search2: {
      BpmId: (_, context) => Commons.EncryptAES(context.bpmId || ''),
      BpdId: (_, context) => Commons.EncryptAES(context.bpdId || ''),
      BpdiId: (_, context) => Commons.EncryptAES(context.bpdiId || ''),
    },
    /** GetSapBasic02R3 — 같은 사업장·직책으로 가장 최근에 저장된 평가항목(디폴트 템플릿) 조회 */
    search3: {
      Position: (_, context) => Commons.EncryptAES(context.position || ''),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
    },

    save1: {
      BpmId: (row) => Commons.EncryptAES(row.bpmId || ''),
      ManagerId: (row) => Commons.EncryptAES(row.managerId || ''),
      Position: (row) => Commons.EncryptAES(row.position || ''),
      ManageDate: (row) =>
        Commons.EncryptAES(dayjs(row.manageDate).format('YYYY-MM-DD') || ''),
      FileName: (row) => Commons.EncryptAES(row.fileName || ''),
      SaveName: (row) => Commons.EncryptAES(row.saveName || ''),
      FilePath: (row, context) =>
        Commons.EncryptAES(
          `SafetyPersonnel/${context.search?.custCd}/SAP_BASIC_02/${row.saveName}` ||
            ''
        ),
      CustCd: (_, context) => context.search?.custCd || '',
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? (context.search?.coCd ?? context.userInfo?.coCd ?? '')
            : (context.userInfo?.coCd ?? '')
        ), // TB_BS_MEMBER 직책 갱신용 (서버 U1 내부에서 사용)
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    save2: {
      Request: (row) => Commons.EncryptAES(row.request),
      UserId: (_, context) => context.userInfo?.userid,
    },
    delete1: {
      BpdId: (row) => Commons.EncryptAES(row.bpdId),
    },
  },
};
